export default "__VITE_ASSET__D2za8o2O__"